export enum ProjectStatus {
  ACTIVE = 2,
  INACTIVE = 9,
}
